import { render, staticRenderFns } from "./CreateEditPolicy.vue?vue&type=template&id=1d97d3de&scoped=true&"
import script from "./CreateEditPolicy.vue?vue&type=script&lang=js&"
export * from "./CreateEditPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditPolicy.vue?vue&type=style&index=0&id=1d97d3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97d3de",
  null
  
)

export default component.exports